import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Table from '../../atoms/table/Table';
import InvoiceTableHeader from '../../molecules/table/InvoiceTableHeader';
import InvoiceTableRow from '../../molecules/table/InvoiceTableRow';
import NoDataTableRow from '../../molecules/table/NoDataTableRow';
const InvoiceTable = ({ invoices }) => {
    return (_jsxs(Table, { hasBorder: true, children: [_jsx(InvoiceTableHeader, {}), invoices.length > 0 &&
                invoices.map(invoice => (_jsx(InvoiceTableRow, { noHover: true, invoice: invoice }, invoice.id))), invoices.length === 0 && _jsx(NoDataTableRow, {})] }));
};
export default InvoiceTable;
